import { useDeleteModelType } from "./api/deleteModelType";
import { Button } from "reactstrap";


const DeleteModelType = ({handleCloseModal, modelTypeId}: DeleteModelTypeProps)  => {
  
  const deleteModelTypeMutation = useDeleteModelType({ modelTypeId});
  const handleSubmit = async (): Promise<void> => {
    deleteModelTypeMutation.mutateAsync({ 
      modelTypeId: modelTypeId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε το Είδος Συσκευής;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteModelTypeProps{
  modelTypeId: number;
  handleCloseModal: () => void;
}

export default DeleteModelType;